import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-kpiall',
  templateUrl: './kpiall.component.html',
  styleUrls: ['./kpiall.component.css']
})
export class KpiallComponent implements OnInit , OnDestroy {
  FormCode: UntypedFormGroup;
  Formsupport:UntypedFormGroup;
  selecttime = [
    { time: 'ประจำงวดที่ 2 มี.ค. 2565', set: '2022-03-02' },
    { time: 'ประจำงวดที่ 1 เม.ย.  2565', set: '2022-04-01' },
    { time: 'ประจำงวดที่ 2 เม.ย. 2565', set: '2022-04-02' },
    { time: 'ประจำงวดที่ 1 พ.ค. 2565', set: '2022-05-01' },
    { time: 'ประจำงวดที่ 2 พ.ค. 2565', set: '2022-05-02' },
  ];

  userdata: any;
  constructor(private spinner: NgxSpinnerService,private auth:Authenticationservice,private route: ActivatedRoute) {
    this.FormCode = new UntypedFormGroup({
      selectzone: new UntypedFormControl(),
      supporttercode: new UntypedFormControl(),
    });
    this.Formsupport = new UntypedFormGroup({
      selettime: new UntypedFormControl(),
    });
    this.userdata = this.auth.Authention();
    console.log(this.userdata)
    this.Action = new UntypedFormGroup({
      selettime:new UntypedFormControl(''),
      supcode:new UntypedFormControl(''),
      m1tp:new UntypedFormControl('0',Validators.required),
      m1t1tg:new UntypedFormControl('0',Validators.required),
      m1t1tp:new UntypedFormControl('0',Validators.required),
      m1t2tg:new UntypedFormControl('0',Validators.required),
      m1t2tp:new UntypedFormControl('0',Validators.required),
      m1t3tg:new UntypedFormControl('0',Validators.required),
      m1t3tp:new UntypedFormControl('0',Validators.required),


      m2tp:new UntypedFormControl('0',Validators.required),
      m2t1tg:new UntypedFormControl('0',Validators.required),
      m2t1tp:new UntypedFormControl('0',Validators.required),
      m2t2tg:new UntypedFormControl('0',Validators.required),
      m2t2tp:new UntypedFormControl('0',Validators.required),
      m2t3tg:new UntypedFormControl('0',Validators.required),
      m2t3tp:new UntypedFormControl('0',Validators.required),
      m2t4tg:new UntypedFormControl('0',Validators.required),
      m2t4tp:new UntypedFormControl('0',Validators.required),
      m2t5tg:new UntypedFormControl('0',Validators.required),
      m2t5tp:new UntypedFormControl('0',Validators.required),
      m2t6tg:new UntypedFormControl('0',Validators.required),
      m2t6tp:new UntypedFormControl('0',Validators.required),
      m2t7tg:new UntypedFormControl('0',Validators.required),
      m2t7tp:new UntypedFormControl('0',Validators.required),
      m2t8tg:new UntypedFormControl('0',Validators.required),
      m2t8tp:new UntypedFormControl('0',Validators.required),
      m2t9tg:new UntypedFormControl('0',Validators.required),
      m2t9tp:new UntypedFormControl('0',Validators.required),
      m2t10tg:new UntypedFormControl('0',Validators.required),
      m2t10tp:new UntypedFormControl('0',Validators.required),
      m2t11tg:new UntypedFormControl('0',Validators.required),
      m2t11tp:new UntypedFormControl('0',Validators.required),
      m2t12tg:new UntypedFormControl('0',Validators.required),
      m2t12tp:new UntypedFormControl('0',Validators.required),

      m3tp:new UntypedFormControl('0',Validators.required),
      m3t1lb:new UntypedFormControl('-'),m3t1tg:new UntypedFormControl('0',Validators.required),m3t1sc:new UntypedFormControl('0',Validators.required),m3t1tp:new UntypedFormControl('0',Validators.required),
      m3t2lb:new UntypedFormControl('-'),m3t2tg:new UntypedFormControl('0',Validators.required),m3t2sc:new UntypedFormControl('0',Validators.required),m3t2tp:new UntypedFormControl('0',Validators.required),
      m3t3lb:new UntypedFormControl('-'),m3t3tg:new UntypedFormControl('0',Validators.required),m3t3sc:new UntypedFormControl('0',Validators.required),m3t3tp:new UntypedFormControl('0',Validators.required),
      m3t4lb:new UntypedFormControl('-'),m3t4tg:new UntypedFormControl('0',Validators.required),m3t4sc:new UntypedFormControl('0',Validators.required),m3t4tp:new UntypedFormControl('0',Validators.required),
      m3t5lb:new UntypedFormControl('-'),m3t5tg:new UntypedFormControl('0',Validators.required),m3t5sc:new UntypedFormControl('0',Validators.required),m3t5tp:new UntypedFormControl('0',Validators.required),
      m3t6lb:new UntypedFormControl('-'),m3t6tg:new UntypedFormControl('0',Validators.required),m3t6sc:new UntypedFormControl('0',Validators.required),m3t6tp:new UntypedFormControl('0',Validators.required),
      m3t7lb:new UntypedFormControl('-'),m3t7tg:new UntypedFormControl('0',Validators.required),m3t7sc:new UntypedFormControl('0',Validators.required),m3t7tp:new UntypedFormControl('0',Validators.required),
      m3t8lb:new UntypedFormControl('-'),m3t8tg:new UntypedFormControl('0',Validators.required),m3t8sc:new UntypedFormControl('0',Validators.required),m3t8tp:new UntypedFormControl('0',Validators.required),
      m3t9lb:new UntypedFormControl('-'),m3t9tg:new UntypedFormControl('0',Validators.required),m3t9sc:new UntypedFormControl('0',Validators.required),m3t9tp:new UntypedFormControl('0',Validators.required),
      m3t10lb:new UntypedFormControl('-'),m3t10tg:new UntypedFormControl('0',Validators.required),m3t10sc:new UntypedFormControl('0',Validators.required),m3t10tp:new UntypedFormControl('0',Validators.required),

      m4tp:new UntypedFormControl('0',Validators.required),
      m4t1tgA:new UntypedFormControl('0',Validators.required),
      m4t1tpA:new UntypedFormControl('0',Validators.required),
      m4t1tgB:new UntypedFormControl('0',Validators.required),
      m4t1tpB:new UntypedFormControl('0',Validators.required),
      m4t1tgC:new UntypedFormControl('0',Validators.required),
      m4t1tpC:new UntypedFormControl('0',Validators.required),

      m4t2tg:new UntypedFormControl('0',Validators.required),
      m4t2tp:new UntypedFormControl('0',Validators.required),

      m4t31tg:new UntypedFormControl('0',Validators.required),
      m4t31tp:new UntypedFormControl('0',Validators.required),
      m4t32tg:new UntypedFormControl('0',Validators.required),
      m4t32tp:new UntypedFormControl('0',Validators.required),
      m4t33tg:new UntypedFormControl('0',Validators.required),
      m4t33tp:new UntypedFormControl('0',Validators.required),

    });
   }

  public id:any;
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnDestroy(): void {
    this.bydate = null;
    this.date = null;
    this.suplist = null;
  }

  suplist:any;
  LoadSuplist(){
    let time = this.Action.get('selettime').value;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_fnc_brdlotwork_6501_w?Lotdate="+time+"&Partcode="+this.userdata.zonedata;
    axios.get(url).then(res => {
      if (res.data.rowsAffected[0]==0){
        alert('!!! ไม่สำเร็จลอง โหลดหน้าใหม่ +++');
      }
      else {
        this.suplist = (res.data.recordset).filter((el:any)=> el.Supcode !== 'sum');
      }
    }).catch(err => {throw err})

  }
  bydate:any;
  date:any;
  lotedate:any;
  mydatatable:any
  Loadbydate(){
    if (this.mydatatable != undefined)
    { 
      this.mydatatable.destroy();  
    }
    else{
     }

     this.spinner.show();
     axios.get('https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_fnc_brdlotwork_6501_w?Lotdate='+this.date).then(res => {
       if (res.data.rowsAffected[0]==0){
         alert('ไม่มีข้อมูล');
       }
       else {
       this.bydate =  res.data.recordset;
       this.lotedate = this.bydate[0].Lotdate_name;
       setTimeout(() => {
         this.mydatatable = $(this.table.nativeElement).DataTable();
       }, 1500);
       }
      this.spinner.hide();
        }).catch(err => { this.spinner.hide();
        throw(err) 
      });
    
    this.spinner.hide();
  }

  LoadSupdata(){
    let supcode = this.Action.get('supcode').value;
    let data = this.suplist.filter((el:any) => el.Supcode == supcode[0]);
    console.log(data);
    data = data[0];
    this.Action.get('m1t1tg').setValue(data.Target1); this.Action.get('m1t1tp').setValue(data.Barrier11);
    this.Action.get('m1t2tg').setValue(data.Target2); this.Action.get('m1t2tp').setValue(data.Barrier12);
    this.Action.get('m1t3tg').setValue(data.Target3); this.Action.get('m1t3tp').setValue(data.Barrier13);
 
    this.Action.get('m2t1tg').setValue(data.Target4);  this.Action.get('m2t1tp').setValue(data.Barrier14);
    this.Action.get('m2t2tg').setValue(data.Target5);  this.Action.get('m2t2tp').setValue(data.Barrier15);
    this.Action.get('m2t3tg').setValue(data.Target6);  this.Action.get('m2t3tp').setValue(data.Barrier16);
    this.Action.get('m2t4tg').setValue(data.Target7);  this.Action.get('m2t4tp').setValue(data.Barrier17);
    this.Action.get('m2t5tg').setValue(data.Target8);  this.Action.get('m2t5tp').setValue(data.Barrier18);
    this.Action.get('m2t6tg').setValue(data.Target9);  this.Action.get('m2t6tp').setValue(data.Barrier19);
    this.Action.get('m2t7tg').setValue(data.Target10); this.Action.get('m2t7tp').setValue(data.Barrier110);
    this.Action.get('m2t8tg').setValue(data.Target11); this.Action.get('m2t8tp').setValue(data.Barrier111);
    this.Action.get('m2t9tg').setValue(data.Target12); this.Action.get('m2t9tp').setValue(data.Barrier112);
    this.Action.get('m2t10tg').setValue(data.Target13);  this.Action.get('m2t10tp').setValue(data.Barrier113);
    this.Action.get('m2t11tg').setValue(data.Target14);  this.Action.get('m2t11tp').setValue(data.Barrier114);
    this.Action.get('m2t12tg').setValue(data.Target15);  this.Action.get('m2t12tp').setValue(data.Barrier115);

  this.Action.get('m3t1lb').setValue(data.label1); this.Action.get('m3t1tg').setValue(data.Target31); this.Action.get('m3t1sc').setValue(data.Success31); this.Action.get('m3t1tp').setValue(data.Barrier131);
  this.Action.get('m3t2lb').setValue(data.label2); this.Action.get('m3t2tg').setValue(data.Target32); this.Action.get('m3t2sc').setValue(data.Success32); this.Action.get('m3t2tp').setValue(data.Barrier132);
  this.Action.get('m3t3lb').setValue(data.label3); this.Action.get('m3t3tg').setValue(data.Target33); this.Action.get('m3t3sc').setValue(data.Success33); this.Action.get('m3t3tp').setValue(data.Barrier133);
  this.Action.get('m3t4lb').setValue(data.label4); this.Action.get('m3t4tg').setValue(data.Target34); this.Action.get('m3t4sc').setValue(data.Success34); this.Action.get('m3t4tp').setValue(data.Barrier134);
  this.Action.get('m3t5lb').setValue(data.label5); this.Action.get('m3t5tg').setValue(data.Target35); this.Action.get('m3t5sc').setValue(data.Success35); this.Action.get('m3t5tp').setValue(data.Barrier135);
  this.Action.get('m3t6lb').setValue(data.label6); this.Action.get('m3t6tg').setValue(data.Target36); this.Action.get('m3t6sc').setValue(data.Success36); this.Action.get('m3t6tp').setValue(data.Barrier136);
  this.Action.get('m3t7lb').setValue(data.label7); this.Action.get('m3t7tg').setValue(data.Target37); this.Action.get('m3t7sc').setValue(data.Success37); this.Action.get('m3t7tp').setValue(data.Barrier137);
  this.Action.get('m3t8lb').setValue(data.label8); this.Action.get('m3t8tg').setValue(data.Target38); this.Action.get('m3t8sc').setValue(data.Success38); this.Action.get('m3t8tp').setValue(data.Barrier138);
  this.Action.get('m3t9lb').setValue(data.label9); this.Action.get('m3t9tg').setValue(data.Target39); this.Action.get('m3t9sc').setValue(data.Success39); this.Action.get('m3t9tp').setValue(data.Barrier139);
  this.Action.get('m3t10lb').setValue(data.label10); this.Action.get('m3t10tg').setValue(data.Target40); this.Action.get('m3t10sc').setValue(data.Success40); this.Action.get('m3t10tp').setValue(data.Barrier140);



 
    this.Action.get('m4t1tgA').setValue(data.Target16);    this.Action.get('m4t1tpA').setValue(data.Barrier116);
    this.Action.get('m4t1tgB').setValue(data.Target17);    this.Action.get('m4t1tpB').setValue(data.Barrier117);
    this.Action.get('m4t1tgC').setValue(data.Target18);    this.Action.get('m4t1tpC').setValue(data.Barrier118);
    this.Action.get('m4t2tg').setValue(data.Target19);     this.Action.get('m4t2tp').setValue(data.Barrier119);
    this.Action.get('m4t31tg').setValue(data.Target20);    this.Action.get('m4t31tp').setValue(data.Barrier120);
    this.Action.get('m4t32tg').setValue(data.Target21);    this.Action.get('m4t32tp').setValue(data.Barrier121);
    this.Action.get('m4t33tg').setValue(data.Target22);    this.Action.get('m4t33tp').setValue(data.Barrier122);
    this.Action.get('m1tp').setValue(data.Barrier21);
    this.Action.get('m2tp').setValue(data.Barrier22);
    this.Action.get('m3tp').setValue(data.Barrier23);
    this.Action.get('m4tp').setValue(data.Barrier24);
  }
  @ViewChild('table') table: ElementRef;
  ExportExcel()
  {
  const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, 'ข้อมูลสรุป KPI งวด.xlsx');
  }


  Action:UntypedFormGroup;
  submitted = false;
  get f() { return this.Action.controls; }
  SaveData(){
    this.submitted = true;

      // stop here if form is invalid
      if (this.Action.invalid) {
          return;
      }

    let data = this.Action.value;
    let time = data.selettime;
    let sc = data.supcode[0];
    console.log(data);
    let url ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_brdlotwork_w?Supcode=" + sc
    +"&Lotdate=" + time
    +"&Supzone=" + data.supcode[1]
    +"&Target1="+(data.m1t1tg)  +"&Barrier11="+data.m1t1tp
    +"&Target2="+(data.m1t2tg)  +"&Barrier12="+(data.m1t2tp)
    +"&Target3="+(data.m1t3tg)  +"&Barrier13="+(data.m1t3tp)
 
    +"&Target4="+(data.m2t1tg)  +"&Barrier14="+(data.m2t1tp)
    +"&Target5="+(data.m2t2tg)  +"&Barrier15="+(data.m2t2tp)
    +"&Target6="+(data.m2t3tg)  +"&Barrier16="+(data.m2t3tp)
    +"&Target7="+(data.m2t4tg)  +"&Barrier17="+(data.m2t4tp)
    +"&Target8="+(data.m2t5tg)  +"&Barrier18="+(data.m2t5tp)
    +"&Target9="+(data.m2t6tg)  +"&Barrier19="+(data.m2t6tp)
    +"&Target10="+(data.m2t7tg) +"&Barrier110="+(data.m2t7tp)
    +"&Target11="+(data.m2t8tg)  +"&Barrier111="+(data.m2t8tp)
    +"&Target12="+(data.m2t9tg)  +"&Barrier112="+(data.m2t9tp)
    +"&Target13="+(data.m2t10tg)  +"&Barrier113="+(data.m2t10tp)
    +"&Target14="+(data.m2t11tg)   +"&Barrier114="+(data.m2t11tp)
    +"&Target15="+(data.m2t12tg)  +"&Barrier115="+(data.m2t12tp)
 
    +"&Target16="+(data.m4t1tgA)  +"&Barrier116="+(data.m4t1tpA)
    +"&Target17="+(data.m4t1tgB)  +"&Barrier117="+(data.m4t1tpB)
    +"&Target18="+(data.m4t1tgC)  +"&Barrier118="  +(data.m4t1tpC)
    +"&Target19="+(data.m4t2tg)   +"&Barrier119="+(data.m4t2tp)
    +"&Target20="+(data.m4t31tg) +"&Barrier120=" +(data.m4t31tp)
    +"&Target21="+(data.m4t32tg) +"&Barrier121=" +(data.m4t32tp)
    +"&Target22="+(data.m4t33tg) +"&Barrier122=" +(data.m4t33tp)
    +"&Barrier21=" +(data.m1tp)
    +"&Barrier22=" +(data.m2tp)
    +"&Barrier24=" +(data.m4tp)

    +"&label1=" +(data.m3t1lb) +"&label2=" +(data.m3t2lb) +"&label3=" +(data.m3t3lb) +"&label4=" +(data.m3t4lb) +"&label5=" +(data.m3t5lb)
    +"&label6=" +(data.m3t6lb) +"&label7=" +(data.m3t7lb) +"&label8=" +(data.m3t8lb)+"&label9=" +(data.m3t9lb) +"&label10=" +(data.m3t10lb)

    +"&Target31=" +(data.m3t1tg) +"&Success31=" +(data.m3t1sc) +"&Barrier131=" +(data.m3t1tp)
    +"&Target32=" +(data.m3t2tg) +"&Success32=" +(data.m3t2sc) +"&Barrier132=" +(data.m3t2tp)
    +"&Target33=" +(data.m3t3tg) +"&Success33=" +(data.m3t3sc) +"&Barrier133=" +(data.m3t3tp)
    +"&Target34=" +(data.m3t4tg) +"&Success34=" +(data.m3t4sc) +"&Barrier134=" +(data.m3t4tp)
    +"&Target35=" +(data.m3t5tg) +"&Success35=" +(data.m3t5sc) +"&Barrier135=" +(data.m3t5tp)
    +"&Target36=" +(data.m3t6tg) +"&Success36=" +(data.m3t6sc) +"&Barrier136=" +(data.m3t6tp)
    +"&Target37=" +(data.m3t7tg) +"&Success37=" +(data.m3t7sc) +"&Barrier137=" +(data.m3t7tp)
    +"&Target38=" +(data.m3t8tg) +"&Success38=" +(data.m3t8sc) +"&Barrier138=" +(data.m3t8tp)
    +"&Target39=" +(data.m3t9tg) +"&Success39=" +(data.m3t9sc) +"&Barrier139=" +(data.m3t9tp)
    +"&Target40=" +(data.m3t10tg) +"&Success40=" +(data.m3t10sc) +"&Barrier140=" +(data.m3t10tp)
    ;
    console.log(url);
    // axios.post(url).then(res => {
    //   if (res.data.rowsAffected[0]==1){
    //     alert('บันทึกข้อมูลแล้ว');
    //     setTimeout(() => {
    //     this.LoadSuplist();

    //     }, 1500);
    //   }
    //   else {
    //    alert('!!! ไม่สำเร็จลอง บันทึกข้อมูลใหม่ +++');
    //   }
    // }).catch(err => {throw err})
  }

  // StrToFl(data:any){
  //   data.toString().replace(/\,/g,'');
  //   return parseFloat(data);
    
  // }

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57 )) {
      return false;
    }
    return true;
    // if (charCode > 31 && (charCode < 44 || charCode > 57 )) {
    //   return false;
    // }
    // return true;
  }

  goPrint(){
    window.print();
  }
}


